import { useState } from "react";
import { useDispatch } from "react-redux";

import {
    Box,
    Input,
    Stack,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Avatar,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import AdminInputs from "./AdminInputs";
import { addAdmin } from "../../features/admin/AdminApi";

export default function AddAdmin() {
    const [open, setOpen] = useState(false);
    const [check, setCheck] = useState(true);
    const [imageData, setImageData] = useState("#");
    const dispatch = useDispatch();

    const handleClickOpen = () => {
        setCheck(true);
        setImageData("#");
        setOpen(true);
    };

    const handleClose = () => {
        setCheck(true);
        setOpen(false);
    };

    const handleCheck = (e) => {
        setCheck(e.target.checked);
    };

    const imageInputChange = (e) => {
        const [file] = e.target.files;
        if (file) {
            setImageData(URL.createObjectURL(file));
        }
    };

    const handleAdd = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        formData.append("active", check ? 1 : 0);
        // Display the key/value pairs
        // for (var pair of formData.entries()) {
        //     console.log(pair[0] + ", " + pair[1]);
        // }
        dispatch(addAdmin({ data: formData }));
        //close the model box
        setOpen(false);
    };

    return (
        <>
            <Button startIcon={<Add />} onClick={handleClickOpen}>
                Add
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                component="form"
                onSubmit={handleAdd}
            >
                <DialogContent>
                    <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="space-between"
                    >
                        <DialogContentText sx={{ padding: "20px 35px " }}>
                            Add Admin
                        </DialogContentText>
                        <Box>
                            <label htmlFor="contained-button-file">
                                <Input
                                    accept="image/*"
                                    id="contained-button-file"
                                    type="file"
                                    name="profile"
                                    sx={{
                                        display: "none",
                                    }}
                                    onChange={imageInputChange}
                                />
                                <Avatar
                                    sx={{
                                        width: 70,
                                        height: 70,
                                        cursor: "pointer",
                                    }}
                                    variant="rounded"
                                    src={imageData}
                                />
                            </label>
                        </Box>
                    </Stack>
                    <AdminInputs
                        setCheck={setCheck}
                        handleCheck={handleCheck}
                        checked={check}
                        setImageData={setImageData}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: "15px 35px" }}>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Add</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
